import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export const downloadPDF = (page, name, fun) => {
  console.log(page)
  html2canvas(page).then(function(canvas) {
    console.log(canvas)
    canvas2PDF(canvas, name);
    fun(false);
  });
};
const canvas2PDF = (canvas, name) => {
  var contentWidth = canvas.width;
  var contentHeight = canvas.height;
  //一页pdf显示html页面生成的canvas高度;
  var pageHeight = (contentWidth / 592.28) * 841.89;
  //未生成pdf的html页面高度
  var leftHeight = contentHeight;
  //页面偏移
  var position = 0;
  //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
  var imgWidth = 585.28;
  var imgHeight = (582.28 / contentWidth) * contentHeight;
  var pageData = canvas.toDataURL("image/jpeg", 1.0);
  var PDF = new jsPDF("", "pt", "a4");
  if (leftHeight < pageHeight) {
    PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
  } else {
    while (leftHeight > 0) {
      PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
      leftHeight -= pageHeight;
      position -= 841.89;
      if (leftHeight > 0) {
        PDF.addPage();
      }
    }
  }
  PDF.save(name + ".pdf"); // 这里是导出的文件名
};



// WEBPACK FOOTER //
// ./src/libs/pdf.js